const newRenderAllCartGoals = () => {
        let customRootElementCartPage = window.tlCartGoalEmbed.cartDisplay;
        let customRootElementCartDraw = window.tlCartGoalEmbed.cartDrawDisplay;

        const allCartGoalContainers = document.querySelectorAll(".tl__cart-goal__container__drawer, .tl-custom-cart-goal-container");
        if (allCartGoalContainers.length) {
            allCartGoalContainers.forEach(ele => ele.remove());
        }

        // inject cart goals into cart drawer and cart page
        if (customRootElementCartPage.selector || customRootElementCartDraw.selector) {
            if (customRootElementCartPage.selector) {
                if(customRootElementCartPage.position === "prepend"){
                    document.querySelectorAll(customRootElementCartPage.selector).forEach((ele, index) => {
                        let htmlObject = document.createElement('div');
                        htmlObject.classList.add('tl-custom-cart-goal-container');
                        htmlObject.innerHTML = window.tlCartGoalEmbed.renderCartGoal(index);
                        ele.prepend(htmlObject)
                    });
                } else {
                    let position = customRootElementCartPage.position === "before" ? "beforebegin" : "afterend";
                    document.querySelectorAll(customRootElementCartPage.selector).forEach((ele, index) => ele.insertAdjacentHTML(position, window.tlCartGoalEmbed.renderCartGoal(index)));
                }
            }
            if (customRootElementCartDraw.selector) {
                let position;
                if (customRootElementCartDraw.position === "prepend") {
                    position = "prepend";
                    document.querySelectorAll(customRootElementCartDraw.selector).forEach((ele, index) => {
                        let htmlObject = document.createElement('div');
                        htmlObject.classList.add('tl-custom-cart-goal-container');
                        htmlObject.innerHTML = window.tlCartGoalEmbed.renderCartGoal(index);
                        ele.prepend(htmlObject)});
                } else {
                    position = customRootElementCartDraw.position === "before" ? "beforebegin" : "afterend";
                    document.querySelectorAll(customRootElementCartDraw.selector).forEach((ele, index) => ele.insertAdjacentHTML(position, window.tlCartGoalEmbed.renderCartGoal(index)));
                }

            }
        } else {
            if (window.tlCartGoalEmbed.cartTotal === 0) {
                window.tlCartGoalEmbed.ROOT_SELECTOR_POSITION = "beforebegin";
            }
            document.querySelectorAll(window.tlCartGoalEmbed.ROOT_SELECTOR_ELEMENT).forEach((ele, index) => {
                ele.insertAdjacentHTML(window.tlCartGoalEmbed.ROOT_SELECTOR_POSITION, window.tlCartGoalEmbed.renderCartGoal(index))
            });
        }

        /*============ Overide function renderAllCartGoals ============ */

        let cartGoalEls = document.querySelectorAll(".tl-custom-cart-goal-container");
        if (cartGoalEls.length === 0) {
            cartGoalEls = document.querySelectorAll(".tl__cart-goal__container__drawer");
        }
        cartGoalEls.forEach((el) => {
            const html = el.innerHTML;
            const parent = el.parentNode;
            const positionRef = el;

            const shadowHost = document.createElement("div");
            shadowHost.classList.add("tl-custom-cart-goal-container");
            shadowHost.style.backgroundColor = "#FFFFFF";

            
            const shadowRoot = shadowHost.attachShadow({ mode: "open" });

            
            shadowRoot.innerHTML = `
                <style>
                    :root {
                        --tl__cart-goal__subdued-color: #ececec;
                        --tl__cart-goal__primary-color: #9e58bb;
                        --tl__cart-goal__filled-bar-color: #9e58bb;
                        --tl__cart-goal__milestone-label-color: #303030;
                        --tl__cart-goal__title_label-color: #303030;

                        /*Container style*/
                        --tl__cart-goal__container__background: rgba(255, 255, 255, 1);
                        --tl__cart-goal__container__border-color: #303030;
                        --tl__cart-goal__container__border-width: 0px;
                        --tl__cart-goal__container__border-radius: 10px;
                        --tl__cart-goal__container__reward-text-color : #303030;

                        /*Free gift modal*/
                        --tl__cart-goal__gift-modal__free-text: #9e58bb;
                        --tl__cart-goal__gift-modal__check-box: #9e58bb;
                        --tl__cart-goal__gift-modal__background: #ffffff;
                        --tl__cart-goal__gift-modal__button-color: #9e58bb;
                        --tl__cart-goal__gift-modal__border-color: #9e58bb;
                        --tl__cart-goal__gift-modal__border-width: 0px;
                        --tl__cart-goal__gift-modal__border-radius: 5px;
                        /*section reward*/
                        --tl__cart-goal__section-reward__button-color: #9e58bb;
                        --tl__cart-goal__section-reward__button-selected-color: #d9cdcd;
                    }
                    .tl-custom-cart-goal-container{
                        background-color: #FFFFFF !important;
                    }

                    #tl__cart-goal__container {
                        margin-bottom: 10px;
                    }

                    .tl__cart-goal__goal-container {
                        background-color: var(--tl__cart-goal__subdued-color);
                        height: 10px;
                        border-radius: 5px;
                        position: relative;
                        margin: 60px 30px 80px 10px;
                    }

                    .tl__cart-goal__goal-check-point {
                        position: absolute;
                        width: 40px;
                        height: 40px;
                        border: 1px solid;
                        border-radius: 50%;
                        top: -15px;
                        padding: 5px;
                        background-color: white;
                        display: flex;
                        gap: 5px;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                    }

                    .tl__cart-goal__goal-check-point {
                        text-wrap: nowrap;
                    }

                    .tl__cart-goal__goal-check-point>p {
                        visibility: visible !important;
                    }

                    .tl__cart-goal__goal-check-point:hover>p {
                        visibility: visible;
                    }

                    .tl__cart-goal__goal-process {
                        background-color: var(--tl__cart-goal__filled-bar-color);
                        height: inherit;
                        border-radius: inherit;
                        transition: width 1s ease-in-out;
                        width: 0%
                    }

                    .tl__cart-goal__reward-description {
                        color: var(--tl__cart-goal__title_label-color);
                        font-size: 1.2em;
                        font-weight: 500;
                        text-align: center;
                    }

                    div[class^="tl__cart-goal__free-gift-container"] {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                    }

                    .tl__cart-goal__free-gift-container-image {
                        width: 40px;
                        height: 40px;
                    }

                    .tl__cart-goal__product-image {
                        width: auto;
                        height: 80px;
                        max-width: 80px;
                        position: relative;
                        min-width: 80px;
                    }

                    .tl__cart-goal__product-image img {
                        border-radius: 4px;
                        width: 100%;
                        height: 100%;
                    }

                    .tl__cart-goal__check-box-input {
                        display: none
                    }

                    .tl__cart-goal__check-box {
                        margin-right: 10px;
                        width: 20px;
                        min-width: 20px;
                        height: 20px;
                        border-radius: 4px;
                        outline: 2px solid var(--tl__cart-goal__gift-modal__check-box) !important;
                        cursor: pointer;
                        display: block !important;
                    }

                    .tl__cart-goal__check-box--active {
                        width: 20px;
                        height: 20px;
                        min-width: 20px;
                        border-radius: 4px;
                        outline: 2px solid var(--tl__cart-goal__gift-modal__check-box);
                        border: 2px solid white;
                        background-color: var(--tl__cart-goal__gift-modal__check-box);
                        display: block !important;
                    }

                    .tl__cart-goal__product-image-info>p {
                        margin: 0;
                        font-weight: 600;
                        font-size: 15px;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        white-space: normal;
                        cursor: pointer;
                        line-height: 16px;
                    }

                    .tl__cart-goal__product-image-info>p:hover {
                        -webkit-line-clamp: unset;
                    }

                    .tl__cart-goal__product-image-info>span:nth-child(2) {
                        font-size: 14px;
                        margin-right: 5px;
                    }

                    .tl__cart-goal__product-image-info>span:nth-child(3) {
                        display: inline-block;
                        font-size: 14px;
                        background-color: var(--tl__cart-goal__gift-modal__free-text);
                        border-radius: 6px;
                        padding: 0 5px;
                        color: white;
                    }

                    .tl__cart-goal__product-quantity{
                        width: 20px;
                        height: 20px;
                        position: absolute;
                        border-radius: 50%;
                        background-color: #797979;
                        line-height: 20px;      
                        text-align: center;
                        font-size: 12px;
                        color: white;
                        top:-7px;
                        left: 72px;
                    }

                    .tl__cart-goal__free-gift-reward-title {
                        margin: 0;
                        font-weight: 600;
                    }

                    .tl__cart-goal__free-gift-reward-body {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                        gap:5px;
                        position: relative;
                    }

                    .tl__cart-goal__gift-noti,
                    .tl__cart-goal__gift-noti__cart-page {
                        background: var(--tl__cart-goal__filled-bar-color);
                        border-radius: 6px;
                        color: white;
                        cursor: pointer;
                        width: 40%;
                        font-size: 14px;
                        height: fit-content;
                        align-self: center;
                        text-align: center;
                        max-width: 120px;
                    }

                    .tl__cart-goal__gift-noti__cart-page {
                        align-self: center;
                        padding: 0px 5px;
                        background: var(--tl__cart-goal__filled-bar-color);
                        border-radius: 6px;
                        display: flex;
                        align-items: center;
                        gap: 2px;
                        color: white;
                        cursor: pointer;
                        margin-bottom: 10px;
                        width: 20%;
                        font-size: 14px;
                        justify-content: space-around;
                    }

                    .tl__cart-goal__active {
                        display: flex;
                    }

                    .tl__cart-goal__list-gifts {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        overflow-y: auto;
                        max-height: 800px;
                        border-radius: var(--tl__cart-goal__gift-modal__border-radius);
                        background: var(--tl__cart-goal__gift-modal__background);
                        position: absolute;
                        top: 30%;
                        width: 95%;
                        max-width: 600px;
                        left: 50%;
                        transform: translateX(-50%);
                        border: var(--tl__cart-goal__gift-modal__border-width) solid var(--tl__cart-goal__gift-modal__border-color);
                    }

                    .tl__cart-goal__list-gifts__cart-page {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        overflow-y: auto;
                        max-height: 800px;
                        border-radius: 5px;
                        background: white;
                        position: absolute;
                        top: 30%;
                        width: 50%;
                        left: 50%;
                        transform: translateX(-50%);
                    }

                    .tl__cart-goal__list-gifts::-webkit-scrollbar {
                        width: 4px;
                    }

                    .tl__cart-goal__button-cancel-gift {
                        width: 50%;
                        font-weight: 550;
                        width: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: var(--tl__cart-goal__gift-modal__button-color);
                        border-top: 1px solid #d9cdcd;
                        cursor: pointer;
                    }

                    .tl__cart-goal__button-add-gift {
                        color: white;
                        background: var(--tl__cart-goal__gift-modal__button-color);
                        cursor: pointer;
                        font-weight: 550;
                        width: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    .tl__cart-goal__gift-modal__cart-page {
                        width: 100%;
                        position: absolute;
                        inset: 0 0 0 0;
                        background: rgba(0, 0, 0, 0.5);
                        z-index: 999;
                        display: none;
                    }
                    .tl__cart-goal__milestone-image {
                        width: 18px;
                        height: 18px;
                    }

                    /* Cart drawer */
                    .tl__cart-goal__goal-container__drawer {
                        background-color: var(--tl__cart-goal__subdued-color);
                        height: 10px;
                        border-radius: 10px;
                        position: relative;
                        margin: 30px 65px 60px 10px;
                    }

                    .tl__cart-goal__goal-check-point__drawer {
                        position: absolute;
                        width: 20px;
                        height: 20px;
                        border: 1px solid;
                        border-radius: 50%;
                        top: -10px;
                        padding: 5px;
                        background-color: white;
                        display: flex;
                        gap: 10px;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                    }

                    .tl__cart-goal__goal-check-point__drawer {
                        white-space: nowrap;
                    }

                    .tl__cart-goal__goal-check-point__drawer>p {
                        visibility: visible !important;
                        font-size: 12px;
                        margin: 0px;
                        font-weight: 600;
                    }

                    .tl__cart-goal__goal-check-point-value{
                        color: var(--tl__cart-goal__milestone-label-color); 
                        padding-bottom:2px;
                    }

                    .tl__cart-goal__goal-container__drawer:hover .tl__cart-goal__goal-check-point__drawer p {
                        visibility: visible !important;
                    }

                    .tl__cart-goal__goal-container__drawer:hover .tl__cart-goal__goal-check-point__drawer:hover p {
                        visibility: visible !important;
                    }

                    .tl__cart-goal__goal-check-point-title{
                        min-height: 25px; 
                        color: var(--tl__cart-goal__milestone-label-color); 
                        padding-top:0px;
                        min-width: 80px;
                        line-height: 1.4;
                        text-align: center;
                        white-space: normal;
                        word-wrap: break-word;  
                    }
                    @media only screen and (max-width: 560px) {
                        .tl__cart-goal__goal-check-point__drawer > p {
                            inline-size: auto !important;
                        }
                    }


                    .tl__cart-goal__goal-check-point__drawer:hover>p {
                        visibility: visible;
                    }

                    .tl__cart-goal__goal-process__drawer {
                        background-color: var(--tl__cart-goal__filled-bar-color);
                        height: inherit;
                        border-radius: inherit;
                        transition: width 1s ease-in-out;
                        width: 0%
                    }

                    .tl__cart-goal__reward-description__drawer {
                        color: var(--tl__cart-goal__title_label-color);
                        font-size: 14px;
                        font-weight: 500;
                        text-align: center;
                        margin-bottom: 0;
                        padding-bottom: 12px;
                    }

                    .tl__cart-goal__container__drawer {
                        width: 100%;
                        
                        border-radius: var(--tl__cart-goal__container__border-radius);
                        background-color: var(--tl__cart-goal__container__background);
                        
                        border: var(--tl__cart-goal__container__border-width) solid var(--tl__cart-goal__container__border-color);
                        /* overflow-x: hidden; */
                    }

                    .tl__cart-goal__container-text-reward{
                        color:var(--tl__cart-goal__container__reward-text-color);
                    }

                    div[class^="tl__cart-goal__gift-modal"] {
                        width: 100%;
                        position: absolute;
                        inset: 0 0 0 0;
                        background: rgba(0, 0, 0, 0.5);
                        z-index: 999;
                        display: none;
                    }

                    @keyframes functionToolkitGrowDown {
                        0% {
                            transform: scaleY(0)
                        }

                        80% {
                            transform: scaleY(0.2)
                        }

                        80% {
                            transform: scaleY(0.4)
                        }

                        80% {
                            transform: scaleY(0.6)
                        }

                        80% {
                            transform: scaleY(0.8)
                        }

                        100% {
                            transform: scaleY(1)
                        }
                    }

                    /* Loader */
                    .tl-cart-goal-loader {
                        border: 3px solid #f3f3f3;
                        border-radius: 50%;
                        border-top: 3px solid #3498db;
                        width: 20px;
                        height: 20px;
                        -webkit-animation: tlCartGoalSpin 1s linear infinite;
                        /* Safari */
                        animation: tlCartGoalSpin 1s linear infinite;
                        display: block !important;
                        margin: 5px 20px;
                    }

                    /* Safari */
                    @-webkit-keyframes tlCartGoalSpin {
                        0% {
                            -webkit-transform: rotate(0deg);
                        }

                        100% {
                            -webkit-transform: rotate(360deg);
                        }
                    }

                    @keyframes tlCartGoalSpin {
                        0% {
                            transform: rotate(0deg);
                        }

                        100% {
                            transform: rotate(360deg);
                        }
                    }

                    @media only screen and (min-width: 920px) {
                        .tl__cart-goal__list-gifts__cart-page {
                            width: 30%;
                        }
                    }


                    .tl__cart-goal__goal-check-point__drawer > p {
                        visibility: visible !important;
                    }

                </style>
                ${html}
            `;

            parent.replaceChild(shadowHost, positionRef);
        });

    window.tlCartGoalEmbed.addTrackImpressionEvent();
}
const intervalId = setInterval(() => {
    if (window.tlCartGoalEmbed) {
        clearInterval(intervalId);
        window.tlCartGoalEmbed.renderAllCartGoals = newRenderAllCartGoals;
        console.log("done");
    }
}, 50);

setTimeout(() => {
    clearInterval(intervalId);
}, 3000)